(function() {
  var WORKER_URL = "https://suples-chatbot.suples.workers.dev";

  var launcher = document.getElementById('suples-ai-launcher');
  var panel = document.getElementById('suples-ai-panel');
  var closeBtn = document.getElementById('suples-ai-close');
  var msgsEl = document.getElementById('suples-ai-msgs');
  var inp = document.getElementById('suples-ai-input');
  var sendBtn = document.getElementById('suples-ai-send');
  var history = [];

function getSessionId() {
  try {
    var id = localStorage.getItem('sai_session_id');
    if (!id) {
      id = 'sai_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 10);
      localStorage.setItem('sai_session_id', id);
    }
    return id;
  } catch (e) {
    return null;
  }
}
var sessionId = getSessionId();

  launcher.addEventListener('click', function() {
    panel.style.display = panel.style.display === 'none' ? 'flex' : 'none';
  });
  closeBtn.addEventListener('click', function() {
    panel.style.display = 'none';
  });

  function addMsg(text, who) {
    var row = document.createElement('div');
    row.className = 'sai-row ' + (who === 'user' ? 'user' : 'bot');

    var bubble = document.createElement('div');
    bubble.className = who === 'user' ? 'sai-bubble sai-bubble-user' : 'sai-bubble sai-bubble-bot';

    var products = [];
    var cleanText = text.replace(/\[\[PRODUCTO\|\|(.*?)\|\|(.*?)\|\|(.*?)\]\]/g, function(match, name, price, url) {
      products.push({ name: name.trim(), price: price.trim(), url: url.trim() });
      return '';
    }).trim();

    var links = [];
    cleanText = cleanText.replace(/\[\[LINK\|\|(.*?)\|\|(.*?)\]\]/g, function(match, label, url) {
      links.push({ label: label.trim(), url: url.trim() });
      return '';
    }).trim();

    var options = [];
    cleanText = cleanText.replace(/\[\[OPCION\|\|(.*?)\|\|(.*?)\]\]/g, function(match, label, msg) {
      options.push({ label: label.trim(), msg: msg.trim() });
      return '';
    }).trim();

    var whatsappLinks = [];
cleanText = cleanText.replace(/\[\[WHATSAPP\|\|(.*?)\|\|(.*?)\]\]/g, function(match, label, url) {
  whatsappLinks.push({ label: label.trim(), url: url.trim() });
  return '';
}).trim();


    var showPedidoForm = false;
    cleanText = cleanText.replace(/\[\[PEDIDO_FORM\]\]/g, function() {
      showPedidoForm = true;
      return '';
    }).trim();

    var textNode = document.createElement('div');
    textNode.textContent = cleanText;
    bubble.appendChild(textNode);

    products.forEach(function(p) {
  if (window.suplesProductHandle && p.url.indexOf('/products/' + window.suplesProductHandle) !== -1) {
    return;
  }
  var btn = document.createElement('a');
  btn.href = p.url;
  btn.target = '_blank';
  btn.rel = 'noopener';
  btn.textContent = 'Ver ' + p.name + ' - ' + p.price;
  btn.className = 'sai-product-btn';
  bubble.appendChild(btn);
});

    links.forEach(function(l) {
      var btn = document.createElement('a');
      btn.href = l.url;
      btn.target = '_blank';
      btn.rel = 'noopener';
      btn.textContent = l.label;
      btn.className = 'sai-link-btn';
      bubble.appendChild(btn);
    });

    options.forEach(function(o) {
      var btn = document.createElement('button');
      btn.textContent = o.label;
      btn.className = 'sai-option-btn';
      btn.addEventListener('click', function() { sendMessage(o.msg); });
      bubble.appendChild(btn);
    });

    whatsappLinks.forEach(function(w) {
  var btn = document.createElement('a');
  btn.href = w.url;
  btn.target = '_blank';
  btn.rel = 'noopener';
  btn.className = 'sai-whatsapp-btn';
  btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38c1.44.79 3.06 1.2 4.79 1.2 5.46 0 9.91-4.45 9.91-9.91C21.95 6.45 17.5 2 12.04 2zm5.71 14.14c-.24.68-1.4 1.3-1.94 1.38-.5.08-1.13.11-1.83-.11-.42-.13-.96-.31-1.65-.61-2.9-1.25-4.79-4.17-4.94-4.36-.14-.19-1.18-1.57-1.18-3 0-1.42.75-2.13 1.01-2.42.27-.29.58-.36.78-.36.19 0 .39 0 .56.01.18.01.42-.07.66.5.24.58.83 2 .9 2.15.07.14.11.31.02.5-.09.19-.14.31-.28.47-.14.16-.3.36-.42.48-.14.14-.29.29-.13.57.17.28.75 1.24 1.6 2 1.1.98 2.02 1.29 2.31 1.43.29.14.46.12.63-.07.17-.19.71-.83.9-1.11.19-.29.38-.24.63-.14.26.1 1.64.77 1.92.91.28.14.47.21.53.33.07.13.07.71-.17 1.39z"/></svg><span>' + w.label + '</span>';
  bubble.appendChild(btn);
});


    if (showPedidoForm) {
      var form = document.createElement('div');
      form.className = 'sai-order-form';

      var orderInput = document.createElement('input');
      orderInput.type = 'text';
      orderInput.className = 'sai-order-input';
      orderInput.placeholder = 'Ej: SP21960';

      var emailInput = document.createElement('input');
      emailInput.type = 'email';
      emailInput.className = 'sai-order-input';
      emailInput.placeholder = 'Email de la compra';

      var submitBtn = document.createElement('button');
      submitBtn.type = 'button';
      submitBtn.className = 'sai-order-submit';
      submitBtn.textContent = 'Consultar pedido';

      function submitOrderForm() {
        if (!orderInput.value.trim() || !emailInput.value.trim()) return;
        orderInput.blur();
        emailInput.blur();
        orderInput.disabled = true;
        emailInput.disabled = true;
        submitBtn.disabled = true;
        sendMessage('Mi pedido es ' + orderInput.value.trim() + ' y mi email es ' + emailInput.value.trim());
      }
      submitBtn.addEventListener('click', submitOrderForm);
      emailInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') submitOrderForm(); });
      orderInput.addEventListener('keydown', function(e) { if (e.key === 'Enter') emailInput.focus(); });

      form.appendChild(orderInput);
      form.appendChild(emailInput);
      form.appendChild(submitBtn);
      bubble.appendChild(form);
    }

    row.appendChild(bubble);
    msgsEl.appendChild(row);
    msgsEl.scrollTop = msgsEl.scrollHeight;
    return row;
  }

function playNotifySound() {
  try {
    var ctx = new (window.AudioContext || window.webkitAudioContext)();
    var now = ctx.currentTime;
    [523, 659].forEach(function(freq, i) {
      var osc = ctx.createOscillator();
      var gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0, now + i * 0.1);
      gain.gain.linearRampToValueAtTime(0.06, now + i * 0.1 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.1 + 0.28);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now + i * 0.1);
      osc.stop(now + i * 0.1 + 0.3);
    });
  } catch (e) {}
}

  function addTyping() {
    var row = document.createElement('div');
    row.className = 'sai-row bot';
    var bubble = document.createElement('div');
    bubble.className = 'sai-bubble sai-bubble-bot';
    bubble.innerHTML = '<div class="sai-typing"><span></span><span></span><span></span></div>';
    row.appendChild(bubble);
    msgsEl.appendChild(row);
    msgsEl.scrollTop = msgsEl.scrollHeight;
    return row;
  }

  function sendMessage(text) {
    if (!text || !text.trim()) return;
    addMsg(text, 'user');
    history.push({ role: 'user', content: text });
    inp.value = '';

    var typing = addTyping();

    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: history, productContext: window.suplesProductTitle || null, sessionId: sessionId })
    })
      .then(function(res) { return res.json(); })
      .then(function(data) {
        typing.remove();
        var textBlock = (data.content || []).find(function(b) { return b.type === 'text'; });
        var reply = textBlock ? textBlock.text : 'Perdona, ¿puedes repetir tu consulta?';
        addMsg(reply, 'bot');
        playNotifySound();
        history.push({ role: 'assistant', content: reply });
      })
      .catch(function() {
        typing.remove();
        addMsg('No pude conectar en este momento.\n[[WHATSAPP||Escribir por WhatsApp||https://wa.me/56940538794?text=Te%20hablo%20desde%20Asistente%20Alex%20de%20Suples]]', 'bot');
      });
  }

  sendBtn.addEventListener('click', function() { sendMessage(inp.value); inp.blur(); });
  inp.addEventListener('keydown', function(e) { if (e.key === 'Enter') { sendMessage(inp.value); inp.blur(); } });
  document.querySelectorAll('.suples-ai-chip').forEach(function(btn) {
  btn.addEventListener('click', function() { sendMessage(btn.getAttribute('data-q')); });
});

try {
  var isProductPage = window.theme && window.theme.pageType === 'product';
  var alreadyEngaged = sessionStorage.getItem('sai_engaged');
  var isMobileViewport = window.matchMedia('(max-width: 880px)').matches;
  if (isProductPage && !alreadyEngaged) {
    var proactiveTimer = setTimeout(function() {
      if (sessionStorage.getItem('sai_engaged')) return;
      if (panel.style.display === 'flex') return;
      if (document.visibilityState === 'hidden') return;
      sessionStorage.setItem('sai_engaged', '1');

      if (isMobileViewport) {
        launcher.classList.add('sai-shake');
        setTimeout(function() { launcher.classList.remove('sai-shake'); }, 900);
        return;
      }

      panel.style.display = 'flex';
    var title = window.suplesProductTitle || 'este producto';
        var openingMsg = '¿Tienes dudas sobre ' + title + '? Escríbeme y te ayudo a decidir 🙂';
        msgsEl.innerHTML = '';
        addMsg(openingMsg, 'bot');
        history.push({ role: 'assistant', content: openingMsg });
        playNotifySound();
      }, 25000);

    launcher.addEventListener('click', function() {
      sessionStorage.setItem('sai_engaged', '1');
      clearTimeout(proactiveTimer);
    });
  }
} catch (e) {}
})();